import { render, staticRenderFns } from "./Checkup.vue?vue&type=template&id=c7b0b52e&"
import script from "./Checkup.vue?vue&type=script&lang=js&"
export * from "./Checkup.vue?vue&type=script&lang=js&"
import style0 from "./Checkup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports